import { getRequest } from "@/services/http/http";
import { Status } from "@/hooks/use-status/types";

export const getStatuses = async (statusUrl: string, userIds: string[]) => {
  const params = userIds.map(id => `user=${id}`).join("&");
  const url = `${statusUrl}?${params}`;

  return getRequest<Status[]>(url);
};
